export const goToMenuOption = optionId => {
  let menuHeight = 150
  let optionSelected = document?.getElementById(optionId)

  if (optionSelected) {
    let scrollHeight =
      optionSelected.getBoundingClientRect()?.top + window.scrollY
    let finalScroll = scrollHeight - menuHeight

    window.history.pushState({}, '', '#' + optionId)
    window.scrollTo({
      top: finalScroll,
      behavior: 'smooth',
    })
  } else {
    window.location.hash = optionId
  }
}
